import { useState } from "react";
import { user_register } from "../../utils/endpoints";
import SignInConfirm from "./SignInConfirm";
import InformativaAppaltatore from "../../assets/partials/InformativaAppaltatore";
import InformativaGestore from "../../assets/partials/InformativaGestore";

export default function PrivacyConsent({ context, user_data, is_appaltatore }) {
  const [disable_confirm, setDisableConfirm] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let response = await context.httpRequest("post", user_register, user_data);

    if (!!response && response.result) {
      document.querySelector(".main-panel").classList.add("remove-main-panel");
      context.openModal(<SignInConfirm context={context} />, false);
    }
  };

  return (
    <>
      {is_appaltatore ? <InformativaAppaltatore /> : <InformativaGestore />}
      <form className="mt-3" onSubmit={(e) => handleSubmit(e)}>
        <div className="mb-4 d-flex align-items-center">
          <input
            onChange={() => setDisableConfirm(!disable_confirm)}
            id="consent-give"
            type="checkbox"
            required
          />
          <label className="ms-2 fw-bold" htmlFor="consent-give">
            Accetto le condizioni sulla prvacy
          </label>
        </div>
        <button
          style={{ opacity: disable_confirm ? "0.5" : 1 }}
          className="q8-blue-button p-3 w-100"
          type="submit"
          disabled={disable_confirm}
        >
          CONFERMA
        </button>
      </form>
    </>
  );
}
